import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from "@angular/core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { CommonModule } from "@angular/common";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
  selector: "app-color-checkbox",
  templateUrl: "./color-checkbox.component.html",
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  styleUrl: "./color-checkbox.component.scss",
})
export class ColorCheckboxComponent {
  faCheck = faCheck;
  @Input() isActive = false;
  @Input() color = "";
  @Output() changeColor = new EventEmitter<void>();

  @HostBinding("class.is-active") get getIsActive(): boolean {
    return this.isActive;
  }

  @HostListener("click") onClick(): void {
    this.changeColor.emit();
  }
}
